var path = 'app/scripts/modules/google/src/loadBalancer/configure/http/basicSettings/basicSettings.html';
var html = "<ng-form name=\"location\">\n  <gce-http-load-balancer-basic-settings application=\"ctrl.application\"\n                                         command=\"ctrl.command\"></gce-http-load-balancer-basic-settings>\n</ng-form>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/google/src/loadBalancer/configure/http/basicSettings/basicSettings.html
// module id = 1299
// module chunks = 0